import Avatar from './Avatar';

/** One of the assistant's turns: its mark, then whatever it said. */
const Turn = ({ children, ...props }) => {
  return (
    <div className="flex items-start gap-3" {...props}>
      <Avatar />
      <div className="min-w-0 flex-1 pt-0.5">{children}</div>
    </div>
  );
};

export default Turn;
